// Public-facing changelog. Newest entries first. Each entry has:
//   slug, date (ISO), title, products (array of slugs), tag, body
// Body supports a small set of inline markdown via a custom renderer in
// ChangelogPage. Keep entries crisp — 2–4 short sentences each.

export const CHANGELOG = [
    {
        slug: "kretara-launch",
        date: "2026-02-04",
        title: "Kretara — procurement intelligence — goes live.",
        products: ["kretara"],
        tag: "Launch",
        body: [
            "Seven became seven. **Kretara** joins the platform as our seventh product — built for operators who treat procurement as a strategic act, not a back-office function.",
            "Multi-level approval matrices, vendor scorecards, price-vs-benchmark intelligence, and an AI copilot grounded in your own procurement history. Identity, data, and billing all share the same Scitus account.",
        ],
    },
    {
        slug: "about-and-etymology",
        date: "2026-02-07",
        title: "New About page + product etymology.",
        products: [],
        tag: "Page",
        body: [
            "Launched a proper **About** page that finally says what we are: an operator-grade platform built by Vyastics Technologies in Chennai and Austin.",
            "Added a new etymology section explaining where each product name comes from — Sanskrit roots for the products closest to commerce and people (Mativex, Karya, Vyaahar, Kretara), Latin roots for the ones that deal with precision and proof (Attestra, Acrium, Vexen).",
        ],
    },
    {
        slug: "pricing-bundle-calculator",
        date: "2026-02-07",
        title: "Interactive bundle pricing calculator.",
        products: [],
        tag: "Pricing",
        body: [
            "You no longer need a calculator and a tab full of pricing pages to estimate your bill. The new **bundle calculator** on /pricing applies the 25% multi-product discount and the 20% annual prepay discount live as you tick products.",
            "Pre-fills the contact form with your chosen products when you click through, so the demo team already knows what you're evaluating.",
        ],
    },
    {
        slug: "static-html-prerender",
        date: "2026-02-05",
        title: "Static-HTML prerendering for every page.",
        products: [],
        tag: "Performance",
        body: [
            "Every public page now ships as **pre-rendered static HTML** with the full DOM, structured data, and OpenGraph baked in. This is what makes the site visible to ChatGPT, Claude, Perplexity, and Google's freshest crawlers — no waiting for JavaScript to boot.",
            "Result: ~85% faster first contentful paint and a clean lighthouse SEO score across all 31 routes.",
        ],
    },
    {
        slug: "compare-erp-pages",
        date: "2026-02-03",
        title: "Head-to-head Compare pages — Tally, Zoho Books, SAP B1.",
        products: [],
        tag: "Compare",
        body: [
            "Three new dedicated Compare pages: **Scitus vs Tally**, **Scitus vs Zoho Books**, **Scitus vs SAP Business One** — for prospects already shopping the legacy ERP market.",
            "Each page is an honest, line-item comparison: where the incumbent wins, where Scitus wins, and which company should pick which.",
        ],
    },
    {
        slug: "hashrouter-to-browserrouter",
        date: "2026-02-02",
        title: "Migrated to clean URLs (no more #).",
        products: [],
        tag: "Infrastructure",
        body: [
            "Goodbye `#/products/mativex`. Hello `/products/mativex`. We migrated the entire site from `HashRouter` to `BrowserRouter`, then built a custom static-snapshot pipeline so every route serves real HTML instead of an empty shell.",
            "Old hash URLs continue to redirect to the new clean paths — no broken inbound links.",
        ],
    },
    {
        slug: "ai-crawlable",
        date: "2026-01-29",
        title: "Made the site visible to ChatGPT, Claude, and Perplexity.",
        products: [],
        tag: "Discoverability",
        body: [
            "Added `llms.txt`, FAQPage JSON-LD on every product page, a dedicated AI-summary block, and an explicit XML sitemap. AI assistants can now correctly answer questions about Scitus when their users ask.",
            "If you ask Claude or Perplexity “what does Scitus.ai do?” today, you get our actual positioning back — not someone else's interpretation.",
        ],
    },
    {
        slug: "deliverability-resend",
        date: "2026-01-27",
        title: "Bullet-proof email deliverability via Resend.",
        products: [],
        tag: "Reliability",
        body: [
            "Migrated transactional email to **Resend** with proper DKIM, SPF, and DMARC alignment. Demo-request confirmations now land in Gmail/Outlook inboxes — not spam folders.",
            "Mean delivery time: under 12 seconds. Bounce rate: 0.0%.",
        ],
    },
    {
        slug: "kretara-screenshots",
        date: "2026-01-25",
        title: "Real product screenshots for Kretara.",
        products: ["kretara"],
        tag: "Kretara",
        body: [
            "Replaced placeholder mocks with five real product screenshots showing approval matrices, vendor scorecards, the AI copilot in action, the indent-to-PO flow, and the live spend analytics view.",
        ],
    },
    {
        slug: "blog-expansion",
        date: "2026-01-22",
        title: "Long-form operator insights.",
        products: [],
        tag: "Content",
        body: [
            "Expanded three existing blog posts to 600+ words each with concrete operator examples, schema markup, and a /blog index page. Topics: real-time finance, tax compliance without spreadsheets, and what an operating system for SMEs actually looks like.",
        ],
    },
    {
        slug: "industries-and-verticals",
        date: "2026-01-18",
        title: "Industry-specific landing pages.",
        products: [],
        tag: "Industries",
        body: [
            "Five new industry pages — **Retail**, **Real Estate**, **Healthcare**, **Manufacturing**, **Services** — each with the exact bundle, KPIs, and customer proof that matters for that vertical.",
            "Useful when you're forwarding a link to an operator who wants to see “the version for someone like me.”",
        ],
    },
    {
        slug: "mobile-scroll-fix",
        date: "2026-01-15",
        title: "Smoother mobile navigation.",
        products: [],
        tag: "Bug fix",
        body: [
            "Killed a race condition where page transitions on mobile occasionally jumped to a previous scroll position. Pages now reliably land at the top on every route change.",
        ],
    },
];
